// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2wzld","modalControls":"_3l3Ja","deleteBtnWrapper":"_39ZCa"};